/**
 * Son kullanıcı cüzdanı (#397) — biçim ve doğrulama yardımcıları.
 * Sözleşme: Workspace docs/api-contracts/enduser-wallet-panel.md
 * Para kuruş, Okkalira adet gelir.
 */
import { formatTL } from "../Components/wallet/walletTxUi";

export const OKKALIRA_MAX_GRANT = 100000;
export const OKKALIRA_NOTE_MAX = 200;

/** Kuruş → "125,00 ₺" */
export const formatKurus = (kurus) => formatTL((Number(kurus) || 0) / 100);

/** Okkalira adedi → "1.250" */
export const formatOkkalira = (n) => (Number(n) || 0).toLocaleString("tr-TR");

/** Okkalira yükleme formu hatası; geçerliyse null */
export function okkaliraGrantError(amount, note = "") {
  const n = Number(amount);
  if (amount === "" || amount == null || !Number.isInteger(n) || n < 1 || n > OKKALIRA_MAX_GRANT) {
    return `1 ile ${OKKALIRA_MAX_GRANT.toLocaleString("tr-TR")} arasında tam sayı girin.`;
  }
  if ((note || "").trim().length > OKKALIRA_NOTE_MAX) {
    return `Not en çok ${OKKALIRA_NOTE_MAX} karakter olabilir.`;
  }
  return null;
}

/** Hareket satırının etiketi ve renkleri */
// Kullanıcının cüzdanı: satış bakiyeden çıkar (−) ama başarılı işlemdir —
// kırmızı yalnız ret/hata için (#242); renkler walletTxUi TYPE_BADGE ile aynı
export const WALLET_TX_UI = {
  topup: { label: "Yükleme", chip: "bg-blue-100 text-blue-700", amount: "text-blue-600", sign: "+" },
  payment: { label: "Satış", chip: "bg-emerald-100 text-emerald-700", amount: "text-gray-900", sign: "-" },
  refund: { label: "İade", chip: "bg-orange-100 text-orange-700", amount: "text-orange-600", sign: "+" },
  okkaliraGrant: { label: "Okkalira", chip: "bg-amber-100 text-amber-700", amount: "text-amber-600", sign: "+" },
  // Reddedilen ödeme (#410) — bakiye değişmedi, tutar üstü çizili gösterilir
  rejected: { label: "Ret", chip: "bg-gray-200 text-gray-700", amount: "text-gray-400 line-through", sign: "" },
};

// ─── Ödeme ret kodları (#410) — Workspace docs/api-contracts/employee-only-payment-device.md §7 ───
export const REJECTION_CODE_LABELS = {
  EMPLOYEE_ONLY: "Firma çalışanı değil",
  FOREIGN_FIRM_QUOTA: "Başka firmanın makinesi",
  INSUFFICIENT_BALANCE: "Yetersiz bakiye",
  PERSONAL_WALLET_DISABLED: "Kişisel cüzdan kapalı",
  OKKALIRA_DISABLED: "Okkalira kapalı",
  DEVICE_OFFLINE: "Makine çevrimdışı",
  DEVICE_BUSY: "Makine meşgul",
  DEVICE_REJECTED: "Makine onaylamadı",
};

/** Ret kodunun kısa etiketi; bilinmeyen kod olduğu gibi */
export const rejectionLabel = (code) => REJECTION_CODE_LABELS[code] || code || "Bilinmeyen";

// ─── Okkalira kuru (#400) — Workspace docs/api-contracts/okkalira-spend.md §1 ───
export const OKKALIRA_RATE_MIN = 1;
export const OKKALIRA_RATE_MAX = 10000;

/** Kur formu hatası (kuruş, tam sayı); geçerliyse null */
export function okkaliraRateError(rate) {
  const n = Number(rate);
  if (rate === "" || rate == null || !Number.isInteger(n) || n < OKKALIRA_RATE_MIN || n > OKKALIRA_RATE_MAX) {
    return `${OKKALIRA_RATE_MIN} ile ${OKKALIRA_RATE_MAX.toLocaleString("tr-TR")} kuruş arasında tam sayı girin.`;
  }
  return null;
}
